// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3NVDr","modalForm":"UpgradeEpcsModal_modalForm__2ep3N","modalFooter":"UpgradeEpcsModal_modalFooter__3g3iS"};